export const MAPPED = "mapped"
export const UNMAPPED = "unmapped"
